import { store } from '@core/store/store';
import { createAppHttpClient } from '@hwm/ui-lib/core/http';
import { environment } from '@root/environment';
import axios from 'axios';

export const httpClient = createAppHttpClient(
  (() => store.getState()) as any,
  {
    sessionCookieDomain: environment.sessionCookieDomain,
    sessionCookieIsSecure: environment.sessionCookieSecure,
    sessionIdleTimeout: environment.sessionCookieIdleTimeout,
  },
  {
    baseURL: environment.apiUrl,
  }
);

export default httpClient;

const basicClient = axios.create({
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
});

export const simpleClient = basicClient;
